import identity from 'lodash/identity';
import * as types from '../../actions/actionTypes';
import thdStoreInfoLoaded from './thdStoreInfoLoaded';

const actions = {
  [types.THD_STORE_INFO_LOADED]: thdStoreInfoLoaded,
};

const initialState = {
  stores: [],
};

export default (state = initialState, action) => (actions[action.type] || identity)(state, action);
